import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import {  Cookies } from 'react-cookie';

import PotentialOilCustomers from "./PotentialOilCustomers";
import PotentialPrimaryCustomers from "./PotentialPrimaryCustomers";
import EngineeringSystem from "./EngineeringSystem";
import EngineeringSystem2 from "./EngineeringSystem2";
import RenewalEngineeringSystem from "./RenewalEngineeringSystem";



const styles = theme => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }
    , paper: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },


});

class ChangeSmsReceiverEngineeringSystem  extends Component {
    cookies=new Cookies();
    constructor(props) {
        super(props);
        this.state = {
            value:0,
        }}

    componentDidMount() {

    }
    handleChange= (event,newValue) => {
        this.setState({ value:newValue });
    }
    render() {
        const { classes } = this.props;
        const { value } = this.state;

        return (
            <div>
                <AppBar position="sticky"color="primary" >

                    <Tabs
                        style={{height:'60px',textAlign:'center'}}
                        value={value}
                        onChange={this.handleChange}
                        indicatorColor="secondary"
                        textColor={'#000000'}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                    >

                        <Tab label=" نظام مهندسی (تمدیدی)"/>
                        <Tab label=" نظام مهندسی (بالقوه)"/>
                        <Tab label="تمدیدی های من"/>



                    </Tabs>


                </AppBar>

                {(value===0)?<EngineeringSystem  props={this.props}/>:null}
                {(value===1)?<EngineeringSystem2  props={this.props}/>:null}
                {(value===2)?<RenewalEngineeringSystem  props={this.props}/>:null}





            </div>
        );
    }
}

export default  withStyles(styles)(ChangeSmsReceiverEngineeringSystem);
